// The studio's control styles as Tailwind classes, shared by the components
// (plans/REDESIGN.md, phase 1). Values follow screens/admin/CampaignStudio/generated/studio.css;
// colours come from the tokens, so an agency's own colours apply automatically.

const focus = 'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-focus'
const press = 'transition-[transform,background-color,border-color,color] duration-ui ease-studio active:scale-[.975]'
const disabled = 'disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100'

const btnBase = `inline-flex items-center justify-center gap-[9px] min-h-[40px] rounded-control border px-[15px] py-[9px] text-xs font-semibold leading-normal text-center ${focus} ${press} ${disabled}`

export const button = {
  // studio .btn.primary
  primary: `${btnBase} bg-action border-action text-action-on hover:bg-action-hover hover:border-action-hover`,
  // studio .btn
  secondary: `${btnBase} bg-surface border-line text-ink hover:bg-action-wash`,
  // studio .btn.quiet
  quiet: `${btnBase} bg-transparent border-transparent text-muted hover:text-action hover:bg-action-tint`,
  // destructive actions (delete, deactivate)
  danger: `${btnBase} bg-surface border-line text-bad-ink hover:bg-bad`,
}

// studio input / select / textarea
export const control = `block w-full min-h-[42px] rounded-control border border-line-strong bg-surface text-ink text-sm px-3 py-2.5 placeholder:text-muted ${focus} transition-[border-color] duration-ui`
export const controlReadOnly = 'bg-soft text-muted'
// studio .field > span
export const label = 'block mb-[7px] text-xs font-semibold text-ink'
// studio .error
export const error = 'text-xs leading-normal text-bad-ink mt-1'
// studio .eyebrow
export const eyebrow = 'text-[10px] font-bold uppercase tracking-[1.5px] text-muted'
// studio .pill (+ .good / warn / bad)
export const pill = {
  base: 'inline-flex items-center gap-1.5 rounded-full px-[9px] py-[5px] text-[11px] font-semibold',
  neutral: 'bg-soft text-ink',
  good: 'bg-good text-good-ink',
  warn: 'bg-warn text-warn-ink',
  bad: 'bg-bad text-bad-ink',
  action: 'bg-action-tint text-action',
}
// studio cards / panels
export const card = 'bg-surface text-surface-ink border border-line rounded-card'
export { focus }
